import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import styled from 'styled-components'

import { setMoreFilter } from '../actions'

import bindActionCreators from '../../../../lib/utils/bindActionCreators'

import SearchField from '../../../../lib/components/SearchField'
import { FONTS, COLORS } from '../../../../constants'
import get from 'lodash/get'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 100px;
  height: 30px;
  margin-left: 10px;
  color: white;
  border-color: ${props => props.border};
  border-radius: 4px;
  position: relative;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`

/**
 * @typedef {object} Props
 * @property {typeof setFilter} setFilter
 * @property {typeof exportExcel} exportExcel
 */

/** @extends {Component<Props>} */
export class MoreFilter extends Component {
  /**
   * @param {React.KeyboardEvent<HTMLInputElement>} e
   */
  handleFilterChange = e => {
    const { value } = e.target
    const { setMoreFilter } = this.props

    if (e.key === 'Enter') {
      setMoreFilter('searchTerm', value)
    }
  }

  handleClickExport = e => {
    const { value } = e.target
    const { exportExcel } = this.props

    exportExcel()
  }

  render = () => {
    return (
      <Wrapper>
        <SearchField placeholder="Search by name..." onKeyPress={this.handleFilterChange} />
        <CustomButton bg={COLORS.UPLOAD_COLOR} border={COLORS.UPLOAD_COLOR_BORDER} onClick={this.handleClickExport}>
          Export
        </CustomButton>
      </Wrapper>
    )
  }
}

const mapDispatchToProps = bindActionCreators({
  setMoreFilter
})

export default connect(
  null,
  mapDispatchToProps
)(MoreFilter)



// WEBPACK FOOTER //
// ./src/pages/report/summary-timesheet/components/MoreFilter.jsx